import { Card, ListItemButton, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { ICreateUpdateTask } from '../../../api/type-def';

import controlTask from './Tasks.module.scss';

interface ITaskCardProps {
	task: ICreateUpdateTask;
	taskNumber: number;
	clickHandler: (task: ICreateUpdateTask) => void;
}

const TaskCard = (props: ITaskCardProps) => {
	const { task, taskNumber, clickHandler } = props;
	return (
		<Box>
			<Box data-testid="task-card" className={controlTask['task-card-number']}>
				Task {taskNumber}
			</Box>
			<Card
				key={`${task.taskName}-${task.id}`}
				className={controlTask['task-card-wrapper']}
			>
				<ListItemButton
					selected
					disableRipple
					data-testid="task-card-handle"
					onClick={() => clickHandler(task)}
					className={controlTask['task-card-selector']}
				>
					<Box
						key={`control-task-${task.id}`}
						className={controlTask['task-card']}
					>
						<Typography className={controlTask['task-card-name']}>
							{task.taskName}
						</Typography>
						<Typography className={controlTask['task-card-details']}>
							{task.taskDescription}
						</Typography>
					</Box>
				</ListItemButton>
			</Card>
			<Box className={controlTask['task-card-status']}>{task.status}</Box>
		</Box>
	);
};

export default TaskCard;
